<div [class.error]="control?.errors && control?.dirty">
    <div class="cap-form-field-label">
        <label *ngIf="label" >{{ label }}</label>
    </div>

    <ng-content></ng-content>

    <div class="cap-form-field-validator">
        <cap-validator [control]="control" [customName]="label"></cap-validator>
    </div>
</div>
